import { BookOpen, CalendarCheck, ChevronDown } from "lucide-react";
import { HERO } from "@/data/site";

const Hero = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="home" className="relative flex min-h-[100svh] items-end overflow-hidden bg-navy-950 sm:items-center">
      <img
        src="/media/coach.jpg"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover object-[28%_center]"
      />
      <video
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        poster="/media/coach.jpg"
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover object-[28%_center]"
      >
        <source src="/media/hero.mp4" type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-l from-navy-950/95 via-navy-950/60 to-navy-950/25" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-navy-900 to-transparent" />

      <div className="container-x relative z-10 pb-20 pt-28 sm:pb-24">
        <div className="max-w-2xl">
          <p
            data-testid="hero-badge"
            className="mb-5 inline-flex items-center gap-2 rounded-full border border-teal-400/30 bg-teal-500/10 px-4 py-1.5 text-xs font-semibold text-teal-300"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-teal-400" />
            {HERO.badge}
          </p>
          <h1
            data-testid="hero-title"
            className="text-4xl font-bold leading-[1.25] tracking-tight sm:text-5xl lg:text-6xl"
          >
            {HERO.titleA}
            <span className="mt-1 block text-teal-300">{HERO.titleB}</span>
          </h1>
          <p data-testid="hero-sub" className="mt-6 max-w-xl text-base leading-loose text-ink-soft sm:text-lg">
            {HERO.sub}
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <button
              data-testid="hero-cta-book"
              onClick={() => scrollTo("contact")}
              className="flex min-h-[52px] items-center gap-2 rounded-2xl bg-gold px-6 text-base font-bold text-navy-950 shadow-lg shadow-gold/20 transition hover:-translate-y-0.5 hover:bg-gold-strong"
            >
              <CalendarCheck className="h-5 w-5" />
              {HERO.ctaPrimary}
            </button>
            <button
              data-testid="hero-cta-library"
              onClick={() => scrollTo("library")}
              className="flex min-h-[52px] items-center gap-2 rounded-2xl border border-white/15 bg-white/5 px-6 text-base font-semibold text-ink backdrop-blur transition hover:border-teal-400/50 hover:text-teal-300"
            >
              <BookOpen className="h-5 w-5" />
              {HERO.ctaSecondary}
            </button>
          </div>
        </div>
      </div>

      <div
        aria-hidden="true"
        className="absolute bottom-6 left-1/2 hidden -translate-x-1/2 text-ink-mute sm:block"
      >
        <ChevronDown className="h-6 w-6 animate-bounce" />
      </div>
    </section>
  );
};

export default Hero;
